export const sapboneConfiguration = {
  sapbone_configurations: `SAPBOne configurations`,
  sapbone_sync_history: `SAPBOne sync history`,
  sapbone_never: `Never`,
  sapbone_sync_in_progress: `Sync in progress`,
  sapbone_last_sync: `Last sync`,
  sapbone_selected_sync: `Selected sync`,
  sapbone_recent_syncs: `Recent syncs (last {{shown}} of {{total}})`,
  sapbone_no_history: `No syncs yet. Select Sync now to run the first sync.`,
  sapbone_sync_start_date: `Sync started`,
  sapbone_no_entities: `No entities were synced in this run.`,
  sapbone_no_changes: `No changes`,
  sapbone_created: `Created`,
  sapbone_updated: `Updated`,
  sapbone_failed_entities: `Failed entities`,
  sapbone_entity: `Entity`,
  sapbone_failed: `Failed`,
  sapbone_status_Success: `Success`,
  sapbone_status_PartialSuccess: `Partial success`,
  sapbone_status_Failed: `Failed`,
  sapbone_result_summary: `{{created}} created, {{updated}} updated`,
  sapbone_duration: `Duration {{value}}`,
  sapbone_duration_min_sec: `{{min}} min {{sec}} s`,
  sapbone_duration_sec: `{{sec}} s`,
  sapbone_date_range: `{{date}}, {{start}} to {{end}}`,
  sapbone_detail_MissingItemCode: `{{count}} with lines missing an item code`,
  sapbone_close: `Close`,
  sapbone_entity_Vendor: `Vendors`,
  sapbone_entity_PaymentTerm: `Payment terms`,
  sapbone_entity_PaymentMethod: `Payment methods`,
  sapbone_entity_DeliveryNote: `Delivery notes`,
  sapbone_entity_PurchaseOrder: `Purchase orders`,
  sapbone_entity_Item: `Items`,
  sapbone_entity_VatGroup: `VAT groups`,
  sapbone_entity_Account: `Accounts`,
  sapbone_entity_CostCenter: `Cost centers`,
  sapbone_output_connector: {
    baseurl: "Base URL",
    username: "Username",
    password: "Password",
  },
};
